import React, { useState, useEffect } from 'react';

// The Melbourne Cup sweep notice, at the top of the driver portal and the sorter portal.
// Paul posts it from /melbourne-cup → Messages & texts; it carries the same words for both
// portals and an "Enter the sweep" link to the public page. Sorters can't get web pushes, so
// this card is how the message reaches them. It disappears by itself when the race starts
// (the server decides), and "Hide" tucks it away on this phone until Paul posts a new one.
// Given a `preview` notice it just shows that (the admin page's "how it looks"), no fetch.
const API = '/.netlify/functions/cup-sweep-sb';
const HIDE_KEY = 'hp_cup_notice_hidden';

export default function CupNoticeCard({ preview }) {
  const [fetched, setN] = useState(null);
  const n = preview || fetched;
  const [hidden, setHidden] = useState(() => { try { return localStorage.getItem(HIDE_KEY) || ''; } catch { return ''; } });

  useEffect(() => {
    if (preview) return undefined;
    let alive = true;
    fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'notice' }) })
      .then((r) => r.json()).then((d) => { if (alive && d && d.ok) setN(d.notice); }).catch(() => {});
    return () => { alive = false; };
  }, [preview]);

  if (!n || (!preview && hidden === n.id)) return null;
  const hide = () => { try { localStorage.setItem(HIDE_KEY, n.id); } catch { /* private mode */ } setHidden(n.id); };

  return (
    <div style={{
      border: '1.5px solid var(--hp-gold, #cba54c)', borderRadius: 14, padding: '14px 16px', marginBottom: 14,
      background: 'linear-gradient(135deg, rgba(203,165,76,.16), rgba(203,165,76,.04))',
    }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
        {/* The title often starts with the horse already; don't show two. */}
        {!/^\s*🏇/.test(n.title) && <div style={{ fontSize: '1.6rem', lineHeight: 1 }}>🏇</div>}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 800, fontSize: '1rem', marginBottom: 4 }}>{n.title}</div>
          <div style={{ fontSize: '.88rem', lineHeight: 1.5, whiteSpace: 'pre-wrap', color: 'var(--hp-text, inherit)' }}>{n.body}</div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 12, alignItems: 'center' }}>
        <a href={n.link || '/cup'} target="_blank" rel="noreferrer"
          style={{ flex: 1, textAlign: 'center', background: 'var(--hp-gold, #cba54c)', color: '#14110a', fontWeight: 800, borderRadius: 10, padding: '11px 12px', textDecoration: 'none' }}>
          Enter the sweep →
        </a>
        <button type="button" onClick={preview ? undefined : hide}
          style={{ background: 'transparent', border: '1px solid var(--hp-border, #ccc)', color: 'var(--hp-dim, #888)', borderRadius: 10, padding: '10px 14px', fontWeight: 700, cursor: 'pointer' }}>
          Hide
        </button>
      </div>
    </div>
  );
}
